<script>
import { mapState, mapGetters } from 'vuex';
import Logo from '@/assets/logo/WhiteTextLogo.svg';
import Footer from '@/components/Footer.vue';

export default {
  name: 'LayoutWeb',

  components: {
    Logo,
    Footer,
  },

  computed: {
    ...mapState('ui', ['routeName']),

    ...mapGetters('ui', ['isLanding', 'isAdminView', 'routeLoaded']),
  },
};
</script>

<template>
  <v-app id="v-app">
    <!-- HOMEPAGE LAYOUT -->
    <div v-if="isLanding">
      <router-view />
    </div>

    <!-- ADMIN LAYOUT -->
    <div v-else-if="isAdminView">
      <router-view />
    </div>

    <!-- DEFAULT LAYOUT -->
    <div v-else-if="routeLoaded" class="grid">
      <v-sheet z="3" class="logo-container" @click="$router.push('/')">
        <a @click="$router.push('/')">
          <Logo class="logo" />
        </a>
      </v-sheet>

      <main class="main">
        <router-view />
      </main>

      <aside class="sidebar"></aside>

      <Footer class="footer" />
    </div>

    <div v-else />
  </v-app>
</template>

<style lang="scss" scoped>
.grid {
  display: grid;
  grid-template-columns: 200px 1fr 200px;
  grid-template-rows: 24px 240px 1fr auto;
  grid-template-areas:
    'logo top-bar top-bar'
    'logo main sidebar'
    'drawer main sidebar'
    'footer footer footer';
  grid-gap: 1rem;
  align-content: flex-start;
  justify-items: flex-start;
  min-height: 100vh;
  width: 100%;
  box-sizing: border-box;
  padding: 0 1rem;
}

@media screen and (max-width: 1000px) {
  .grid {
    grid-template-columns: 140px 1fr 0;
    grid-template-rows: 24px 160px 1fr auto;
  }
}

@media screen and (min-width: 1001px) and (max-width: 1200px) {
  .grid {
    grid-template-columns: 200px 1fr 0;
    grid-template-rows: 24px 240px 1fr auto;
  }
}

.logo-container {
  grid-area: logo;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0.5rem;
  border-radius: 0 0 10px 10px;
  background-image: url('~@/assets/backgrounds/BlueBackground.svg?external');
  background-position-y: 95%;
  background-repeat: no-repeat;
  background-size: cover;
}

.logo {
  width: 100%;
  height: auto;
  fill: white;
  filter: drop-shadow(3px 4px 4px rgba(0, 0, 0, 0.14));
}

.top-bar {
  grid-area: top-bar;
}

.drawer {
  grid-area: drawer;
  border-right: none;
  min-width: 200px;
  width: 100%;
}

.main {
  grid-area: main;
  width: 100%;
  max-width: 840px;
  margin: 0 auto;
  padding: 0 1rem;
  box-sizing: border-box;
}

.sidebar {
  grid-area: sidebar;
}

.footer {
  grid-area: footer;
  margin-top: 2rem;
  margin-left: -1rem;
}
</style>
